<template>
  <cl-heading class="tw-flex tw-items-center" :size="'h6'">
    {{ title }}
  </cl-heading>
  <div class="tw-col-span-2 tw-flex tw-justify-end tw-items-baseline tw-mt-1.5">
    <span
      class="tw-text-primary-grey-200"
      v-tippy="{
        content: t('sat-completed-lures-clicked-card-msp'),
        placement: 'top',
      }"
    >
      <cb-icon-information :width="16" />
    </span>
  </div>
</template>
<script lang="ts">
interface IProps {
  isPhsActive: boolean;
  isSatActive: boolean;
}
</script>
<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps<IProps>();
const { t } = useI18n();

const title = computed<string>(() => {
  if (props.isPhsActive && props.isSatActive) {
    return t("sat-completed-lures-clicked");
  }
  if (props.isPhsActive) {
    return t("lures-clicked-legend");
  } else {
    return t("sat-modules-completed");
  }
});
</script>
